import React, { useState } from "react";
import { Form, Row, Col, Input, Drawer, Upload, message, Button, Select } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Option } = Select;

import Api from '../../../../api';
import { dummyRequest } from "../../../../utils/dummyRequest";
import { toastNotification } from "../../../../utils/toastNotification";

const CreateVideos = ({ id, onClose, isVisible, getAllVideos }) => {
  const [form] = Form.useForm();
  const [t, i18n] = useTranslation();

  const [allFonds, setFonds] = useState([]);

  const handleGetAllFonds = () => {
    Api("generals/type/fonds", "GET", null)
      .then((data) => {
        if (!data || !data?.fonds?.length) {
          toastNotification("info", "You cannot create videos, please go add fonds");
        } else {
          setFonds(data?.fonds);
          // setGeneralInfo(data);
          // setVisibleCreate(true);

          // setFonds(data.fonds);
          // setLoading(false);
        }
      })
      .catch(() => setLoading(false));
  };

  const handleSubmit = (formValues) => {
    if(!formValues?.fond_id) return message('error', 'Please select at least one fonds')
    console.log(formValues.image_name.file.originFileObj)
    const formData = new FormData();
    formData.append("fond_id", formValues.fond_id);
    formData.append("name", formValues.name);
    formData.append("link", formValues.link);
    formData.append("files", formValues.image_name.file.originFileObj);

    Api("videos/", "POST", formData, true)
      .then(() => {
        toastNotification("success", "Successfully created video");
        onClose();
        getAllVideos();
      })
      .catch((err) => {
        onClose();
        toastNotification("error", err.error || "Error while creating video");
      });
  };

  return (
    <Drawer
      title="New Video"
      onClose={onClose}
      visible={isVisible}
      width={720}
      footer={
        <div className="footerstyle">
          <Button onClick={onClose} className="buttonstyle">
            {t("cancel")}
          </Button>
          <Button
            type="primary"
            form="customersform"
            key="submit"
            htmlType="submit"
          >
            {t("submit")}
          </Button>
        </div>
      }
    >
      <Form
        form={form}
        id="customersform"
        layout="vertical"
        scrollToFirstError
        onFinish={handleSubmit}
      >
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="fond_id"
              label={t("Choose Fond")}
              rules={[{ required: true, message: `${t("Choose Fond")}` }]}
            >
              <Select placeholder={t("from_customer")} onClick={() => handleGetAllFonds()}>
                {allFonds?.map((item) => (
                  <Option value={item?.id}>{item?.title}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="name"
              label={t("name")}
              rules={[{ required: true, message: `${t("Enter video name")}` }]}
            >
              <Input placeholder={t("Enter video name")} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="link"
              label={t("Link")}
              rules={[{ required: true, message: `${t("Add link")}` }]}
            >
              <Input type="url" placeholder={t("Add link")} />
            </Form.Item>
          </Col>
          <Form.Item
            name="image_name"
            label={t("image")}
            rules={[{ required: true, message: `${t("Please add image")}` }]}
          >
            <Upload maxCount={1} customRequest={dummyRequest}>
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
          </Form.Item>
        </Row>
      </Form>
    </Drawer>
  );
};
export default CreateVideos;
